import React, { PureComponent, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { getHyperLinkTours } from "../../Actions/HomeAction"

const mapStateToProps = (state) => {
    return {
        tour: state.Tour
    }
}
const mapDispatchToProps = dispatch => ({
    getHyperLinkTours: () => dispatch(getHyperLinkTours())
});


function getURL(tour, type) {
    var url = ""
    switch (type) {
        case "Day tour":
            url = "/links/day-tours/" + tour.permalink
            break;
        case "Round tour":
            url = "/links/round-tours/" + tour.permalink
            break;

        case "Excursion":
            url = "/links/things-to-do/" + tour.permalink
            break;

        default:
            break;
    }
    return url
}


function getLimit(char, num) {
    var title = char

    title = title.length > num ? title.substring(0, num) + "..." : title

    return title
}

class Footer extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            isOpenD: false,
            isOpenR: false,
            isOpenH: false,
        }
        this.props.getHyperLinkTours()
    }
    
    toggleExpand = (name,bool) => {
        this.setState({
            [name]: bool
        });
    };

    render() {
        const hyperLinks = this.props.tour.hyperLinks
        return (
            <Fragment>
                {hyperLinks.length > 0 ? <>
                    <div className="hyperlink-tours">
                        <div className="container">
                            <div className="row">

                                <div className={"col-lg-4 hyperlink-tours-div " + (this.state.isOpenD ? 'opn' : '')}>
                                    <h5>Day Tours </h5>
                                    <div className="expn">
                                        {hyperLinks.filter(tour => tour.tour_type == "0").map((tour) => (
                                            <div className="t-infro">
                                                <a href={getURL(tour, "Day tour")}>
                                                    <h6> {getLimit(tour.title, 40)}</h6>
                                                </a>
                                            </div>))}
                                    </div>
                                    <span className="expnbtn">
                                        {this.state.isOpenD ?
                                            <p className="close" onClick={()=>this.toggleExpand("isOpenD",false)}>See less</p> : <p onClick={()=>this.toggleExpand("isOpenD",true)} className="open" >See more</p>
                                        }
                                    </span>
                                </div>


                                <div className={"col-lg-4 hyperlink-tours-div " + (this.state.isOpenR ? 'opn' : '')}>
                                    <h5>Round Tours </h5>
                                    <div className="expn">
                                        {hyperLinks.filter(tour => tour.tour_type == "1").map((tour) => (
                                            <div className="t-infro">
                                                <a href={getURL(tour, "Round tour")}>
                                                    <h6> {getLimit(tour.title, 40)}</h6>
                                                </a>
                                            </div>))}
                                    </div>
                                    <span className="expnbtn">
                                        {this.state.isOpenR ?
                                            <p className="close" onClick={()=>this.toggleExpand("isOpenR",false)}>See less</p> : <p onClick={()=>this.toggleExpand("isOpenR",true)} className="open" >See more</p>
                                        }
                                    </span>
                                </div>
                                <div className={"col-lg-4 hyperlink-tours-div " + (this.state.isOpenH ? 'opn' : '')}>
                                    <h5>Things To Do </h5>
                                    <div className="expn">
                                        {hyperLinks.filter(tour => tour.tour_type == "2").map((tour) => (
                                            <div className="t-infro">
                                                <a href={getURL(tour, "Excursion")}>
                                                    <h6> {getLimit(tour.title, 40)}</h6>
                                                </a>
                                            </div>))}
                                    </div>
                                    <span className="expnbtn">
                                        {this.state.isOpenH ?
                                            <p className="close" onClick={()=>this.toggleExpand("isOpenH",false)}>See less</p> : <p onClick={()=>this.toggleExpand("isOpenH",true)} className="open" >See more</p>
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                </> : null}
            </Fragment>
        );
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Footer);
